<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                :context="context"
                :alvqa="alvqa"
            />
            <ReportButton                 
                :items="reportOptions"
                context="FileReport"
                :alvqa="alvqa"
                cols="2"
            />
            <v-col   
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="LabelStatements" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
            <v-col 
                cols="2"
                align-self="center"
                class="mt-2"
            >
                <BaseButton 
                    v-if="$store.getters.getIsLabelStatementsRunning"
                    label="lang_GENERIC_BUTTON_CAPTION_CHECK_STATUS"
                    block
                    @click="checkStatus()"
                    :alvqa="alvqa + '-list-button-check-statement-status'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ReportButton from '@/components/_buttons/ReportButton'

export default {
    name: "LabelStatementsTopSlot",
    components: {
        ActionDropdown,
        ReportButton,
        BaseHeaderStats,
        BaseButton
    },
    data() {
        return {
            context: "LabelStatements",
            alvqa: "label-statements"
        }
    },
    computed: {
        totalRecords() { return this.$store.getters.getTotalRecords },

        actions() {
            return [
                {
                    text: this.$t("lang_GENERIC_ACTION_OPTION_CAPTION_LAUNCH_STATEMENT_PREVIEW"),
                    value: 'launchStatementRun',
                    alvqa: this.alvqa + '-list-action-dropdown-run-statement'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ARCHIVE_WITH_CARRY_FORWARD"),
                    value: 'archiveWithForwarded',
                    alvqa: this.alvqa + '-list-action-dropdown-archive-with-forwarded'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ARCHIVE_WITHOUT_CARRY_FORWARD"),
                    value: 'archiveWithoutForwarded',
                    alvqa: this.alvqa + '-list-action-dropdown-archive-without-forwarded'
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_DOWNLOAD_BULK'), 
                    value: 'bulkDownload',
                    alvqa: this.alvqa + '-list-action-dropdown-bulk-download'
                }
            ]
        },
        reportOptions(){
            return [
				{
                    text: this.$t('lang_LABEL_STATEMENTS_BALANCE_REPORT_ACCOUNT_BALANCES'), 
                    value: 'balanceReportLabelStatements', 
                    alvqa: this.alvqa + '-list-report-dropdown-balance-report'
                },	
				{
                    text: this.$t('lang_GENERAL_CAPTION_PAYMENT_LIST'), 
                    value: 'paymentListLabelStatements', 
                    alvqa: this.alvqa + '-list-report-dropdown-payment-list' 
                },	
                {
                    text: this.$t('lang_LABEL_STATEMENTS_REPORT_LICENSOR_PAYMENTS'), 
                    value: 'licensorPaymentsReport', 
                    alvqa: this.alvqa + '-list-report-dropdown-licensor-payments' 
                },
                {
                    text: this.$t('lang_LABEL_STATEMENTS_CAPTION_GLOC'), 
                    value: 'glocStatements', 
                    alvqa: this.alvqa + '-list-report-dropdown-gloc-statements' 
                }
			]
        }
    },
    methods: {
        checkStatus() {
            this.$store.dispatch('checkStatusOfStatementsRun', {context: 'LabelStatements', dir: 'label/statements'})
        }
    }
}
</script>